﻿import {useCallback} from "react";

interface UseSimpleTablePaginationHandlers {
  setPage: (value: string) => void;
  setSize: (value: string) => void;
}

const useSimpleTablePaginationHandlers = ({ setPage, setSize }: UseSimpleTablePaginationHandlers) => {
  const handlePageChange = useCallback((_: any, value: number) => {
    setPage(value?.toString());
  }, [setPage]);

  const handleRowsPerPageChange = useCallback((event: any) => {
    setSize(event.target?.value);
  }, [setSize]);

  return {
    handlePageChange,
    handleRowsPerPageChange,
  }
}

export { useSimpleTablePaginationHandlers };
